import script from "./AppNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./AppNavbar.vue?vue&type=script&setup=true&lang=js"

import "./AppNavbar.vue?vue&type=style&index=0&id=aaba60ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aaba60ee"]])

export default __exports__